module.exports = "<nv-react-component component=\"LicenseAnalytics\"></nv-react-component>";